import { gql } from '@apollo/client';

const atlBidEventFragment = gql`
  fragment AtlBidEventFields on OpenForATLBidEvent {
    Id
    EventBid {
      BidDate
    }
  }
`;

export default atlBidEventFragment;
